var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0413\\u043B\\u0430\\u0432\\u043D\\u0430\\u044F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DADADA",
    x: 0,
    y: 0,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#DADADA",
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF",
    x: 6,
    y: 0,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFFFFF",
    x: 0,
    y: 6,
    width: 6,
    height: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.3dc6aeedf0680402ffed54e673151cec.svg";
export { ForwardRef as ReactComponent };